import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { AdminSeasonOverview } from '../../../models/season-admin';
import { SeasonAdminService } from '../../../services/season-admin.service';
import { AdminPageHeaderComponent } from '../../shared/admin-page-header/admin-page-header.component';

@Component({
  selector: 'app-season-wizard',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterModule, AdminPageHeaderComponent],
  templateUrl: './season-wizard.component.html',
  styleUrl: './season-wizard.component.scss',
})
export class SeasonWizardComponent implements OnInit {
  readonly title = 'Nova Temporada';
  readonly subtitle = 'Crie a temporada e o passe inicial com opção de clonar uma temporada template.';

  isSaving = false;
  feedbackError = '';

  templates: AdminSeasonOverview[] = [];
  seasonName = '';
  startDateLocal = '';
  endDateLocal = '';
  battlePassName = '';
  battlePassDescription = '';
  priceGems = 500;
  priceCoins = 2000;
  templateSeasonId?: number;
  cloneMissions = true;
  cloneLevels = true;
  cloneRewards = true;

  constructor(private seasonService: SeasonAdminService, private router: Router) {}

  ngOnInit(): void {
    this.seasonService.templates().subscribe({
      next: (response) => {
        this.templates = response || [];
      },
      error: () => {
        this.templates = [];
      },
    });
  }

  save(): void {
    if (!this.seasonName || !this.startDateLocal || !this.endDateLocal || !this.battlePassName) {
      this.feedbackError = 'Preencha os campos obrigatórios da temporada e do passe.';
      return;
    }

    this.feedbackError = '';
    this.isSaving = true;

    this.seasonService
      .createWithTemplate({
        season: {
          name: this.seasonName.trim(),
          start_date: new Date(this.startDateLocal).toISOString(),
          end_date: new Date(this.endDateLocal).toISOString(),
        },
        battle_pass: {
          name: this.battlePassName.trim(),
          description: this.battlePassDescription.trim(),
          price_gems: this.priceGems,
          price_coins: this.priceCoins,
        },
        template_season_id: this.templateSeasonId,
        clone_missions: this.cloneMissions,
        clone_levels: this.cloneLevels,
        clone_rewards: this.cloneRewards,
      })
      .subscribe({
        next: (season) => {
          this.isSaving = false;
          this.router.navigate(['/dashboard/temporadas', season.id]);
        },
        error: (error) => {
          this.isSaving = false;
          this.feedbackError = this.extractErrorMessage(
            error,
            'Não foi possível criar a temporada.'
          );
        },
      });
  }

  private extractErrorMessage(error: any, fallback: string): string {
    const response = error?.error;
    if (!response) {
      return fallback;
    }

    if (typeof response === 'string') {
      return response;
    }

    if (typeof response?.detail === 'string') {
      return response.detail;
    }

    const fieldMessages: string[] = [];
    Object.entries(response).forEach(([field, value]) => {
      if (Array.isArray(value)) {
        fieldMessages.push(`${field}: ${value.join(', ')}`);
      } else if (typeof value === 'string') {
        fieldMessages.push(`${field}: ${value}`);
      }
    });

    return fieldMessages.length > 0 ? fieldMessages.join(' | ') : fallback;
  }
}
